import calculateTextWidth from '../../utilities/calculateTextWidth';
import { characterForWidthCalc } from '../../settings';

export default function calcWidthFromCharCount(charCount: number) {
  const str = Array(charCount).fill(characterForWidthCalc).join('');
  return calculateTextWidth(str);
}
